'use client'

// @ts-strict-ignore
import clsx from 'clsx'
import React, { ReactNode, useRef, useState } from 'react'

import { SvgArrowDown } from '@/shared/lib/@deprecated/iport-icons/iconsA/SvgArrowDown'

import cl from './Accordion.module.scss'

export const Accordion = ({ title, children }: { title: ReactNode; children: ReactNode }) => {
	const [isOpen, setIsOpen] = useState(false)

	const handleClick = () => {
		setIsOpen(state => !state)
	}
	const contentRef = useRef(null)

	const heightWrapper = isOpen ? contentRef.current.scrollHeight + 'px' : '0px'

	return (
		<div className={cl.main} onClick={handleClick}>
			<div className={cl.header}>
				{title} <SvgArrowDown size={24} className={clsx(cl.icon, { [cl.icon_open]: isOpen })} />
			</div>
			<div style={{ maxHeight: `${heightWrapper}` }} className={cl.contentWrapper}>
				<div ref={contentRef} className={clsx(cl.content, { [cl.content_open]: isOpen })}>
					{children}
				</div>
			</div>
		</div>
	)
}
